const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import Util from "../../../longhudou/module/util";
import Utility from "../../../../utility/utility";
import AppData from "../../const/app_data";
@ccclass
export default class ShareView extends ViewBase {
    @property(cc.Node)
    shareFacebookBtn: cc.Node = null

    facebookDeal() {
        if (cc.sys.os == cc.sys.OS_ANDROID) {
            if (!Utility.version_judge(AppData.appVersion, "1.2.6")) {
                this.shareFacebookBtn.active = false
            }
        }
    }
}